import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Link } from 'react-router-dom';
// import Card from 'react-bootstrap/card';
import logoSaleem from '../images/our-clients/saleem-logo.png';
import logoAdRocket from '../images/our-clients/adrocket-logo.svg';
import logoEMBS from '../images/our-clients/ebms-logo.svg';
import logoSDS from '../images/our-clients/sds-logo.svg';
import logoSST from '../images/our-clients/sst-logo.png';
import logopvtclients from '../images/our-clients/pvt-clients.png';
const OurClieqntsSection = () => {

    const scrollToTop = () => {
        if (typeof window !== 'undefined') {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }   
    }

    return (<div className="pt-3  position-relative overflow-hidden">

        <Container className="my-5">
            <div className="text-center mb-5">
                <div className="position-relative section-title">
                    <h1 className="fs28 title">Our Clients</h1>
                    <span className="mirror-text">Our Clients</span>
                </div>
                <span className="fs16 color-grey3">Trusted by brands that believe in innovation and growth.</span>
            </div>

            <Row>
                <Col lg={{ span: 10, offset: 1 }}>
                    <Row>
                        <Col md={4}>
                            <a href="https://saleemgroup.com/" target="_blank" rel="noopener noreferrer">
                                <div className="client-card">
                                    <img src={logoSaleem} alt="client-logo" />
                                </div>
                            </a>
                        </Col>
                        <Col md={4}>
                            <a href="https://adrocketagency.com/" target="_blank" rel="noopener noreferrer">
                                <div className="client-card">
                                    <img src={logoAdRocket} alt="client-logo" />
                                </div>
                            </a>
                        </Col>
                        <Col md={4}>
                            <a href="https://everydaybeverages.com/" target="_blank" rel="noopener noreferrer">
                                <div className="client-card text-center">
                                    <img src={logoEMBS} alt="client-logo" className='w-75' />
                                </div>
                            </a>
                        </Col>
                        <Col md={4}>
                            <a href="https://sathishdesigners.com/" target="_blank" rel="noopener noreferrer">
                                <div className="client-card">
                                    <img src={logoSDS} alt="client-logo" />
                                </div>
                            </a>
                        </Col>
                        <Col md={4}>
                            <a href="https://ssttechnolggy.wordpress.com/" target="_blank" rel="noopener noreferrer">
                                <div className="client-card text-center">
                                    <img src={logoSST} alt="client-logo" className='w-60' />
                                </div>
                            </a>
                        </Col>
                        <Col md={4}>
                            <a href="#" rel="noopener noreferrer">
                                <div className="client-card text-center">
                                    <img src={logopvtclients} alt="client-logo" className='w-60' />
                                </div>
                            </a>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="text-center">
                            <div className="client-card your-logo">
                                <h3>Our next success story could be you.</h3>
                                <div className="d-flex justify-content-center">
                                    <Link to="/contact-us">
                                        <button type="button" className="btn btn-quote mt-2">
                                            Enquire Now
                                        </button>
                                    </Link>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Col>
            </Row>



        </Container>
    </div>
    );
}

export default OurClieqntsSection;
